<script setup lang="ts">
import { computed } from 'vue'

import { AlertType } from '@/constants/ui'

import LoadingSpinner from '../LoadingSpinner.vue'

interface ButtonAlertPrimaryProps {
  label: string
  type: AlertType
  disabled?: boolean
  loading?: boolean
}

const props = defineProps<ButtonAlertPrimaryProps>()
const colorClasses = {
  [AlertType.danger]: 'bg-radical_red-500',
  [AlertType.info]: 'bg-lochmara-600',
  [AlertType.success]: 'bg-keppel-500',
  [AlertType.warning]: 'bg-lightning_yellow-500',
}

const disabled = computed(() => {
  return props.disabled || props.loading
})
</script>

<template>
  <button
    class="no-edge-dark relative inline-flex items-center justify-center gap-2 rounded-[3.125rem] px-6 py-3 text-base shadow-md"
    :class="[
      props.loading ? 'bg-black-100 text-black-100 hover:cursor-not-allowed' : '',
      props.disabled ? 'bg-black-100 text-white hover:cursor-not-allowed' : '',
      !props.disabled && !props.loading
        ? `${colorClasses[props.type]} text-white hover:cursor-pointer`
        : '',
    ]"
    :disabled="disabled"
    type="button"
  >
    <span class="">{{ props.label }}</span>
    <LoadingSpinner v-if="loading" class="margin-auto absolute" size="1rem" />
  </button>
</template>
